/*
 * Sección Ingresos: quién llegó y a qué hora en el periodo, con la puntualidad contra la hora oficial
 * (08:00 de lunes a viernes, puntual hasta 08:10; la calcula el servidor, spec 4.2). Llegar antes se
 * muestra en verde: se reconoce, no se penaliza. Cada fila lleva su barra de jornada con la línea de
 * las 08:00. Recibe las jornadas ya filtradas por el contenedor (../index.js).
 */
import React, {useEffect, useState} from "react";
import StateView from "../components/StateView";
import SectionHeader from "../components/SectionHeader";
import StatTile from "../components/StatTile";
import StatusBadge from "../components/StatusBadge";
import EmployeeName from "../components/EmployeeName";
import Paginator from "../components/Paginator";
import BarraJornada, {TimelineAxis} from "../components/BarraJornada";
import {arrivalStatus, durationLabel, entryList, entrySummary, formatNumber, hhmm, paginate} from "../utils/rows";
import {buildParams, shortDayLabel} from "../utils/period";

const Ingresos = ({rows, status, message, onRetry, filters, range, today, token, canExport, resetKey}) => {
    const [page, setPage] = useState(1);
    useEffect(() => {
        setPage(1);
    }, [resetKey]);

    const list = entryList(rows);
    const summary = entrySummary(rows);
    const current = paginate(list, page);
    const multiDay = range.desde !== range.hasta;

    return (
        <section className="mc-section" aria-labelledby="mc-title-ingresos">
            <SectionHeader id="mc-title-ingresos" title="Ingresos" canExport={canExport} token={token} range={range}
                           exportParams={buildParams(filters, range, {seccion: 'ingresos'})}/>
            <StateView status={status} message={message} onRetry={onRetry} isEmpty={list.length === 0}>
                <div className="mc-tiles">
                    <StatTile label="Llegadas" value={summary.llegadas} hint={`Hora promedio ${summary.horaPromedio}`}/>
                    <StatTile label="Puntualidad"
                              value={summary.puntualidad === null ? '—' : `${formatNumber(summary.puntualidad)} %`}
                              hint={`${summary.evaluadas} jornadas con hora oficial`}/>
                    <StatTile label="Antes de las 08:00" value={summary.temprano}
                              tone={summary.temprano ? 'up' : 'neutral'} hint="Llegar temprano suma"/>
                    <StatTile label="Llegaron tarde" value={summary.atrasos} tone={summary.atrasos ? 'down' : 'neutral'}
                              hint={summary.atrasos ? `${durationLabel(summary.atrasoTotal)} de atraso en total` : 'Nadie después de las 08:10'}/>
                </div>
                <div className="mc-panel">
                    <div className="mc-list__head" aria-hidden="true">
                        <span>Persona</span><span>Entrada</span><span>Llegada</span><TimelineAxis/>
                    </div>
                    <ul className="mc-list">
                        {current.items.map((row) => {
                            const early = arrivalStatus(row);
                            // adelanto_min en 0 con llegada temprana (segundos de adelanto): "A tiempo", no "0 min antes".
                            const arrival = early.tone === 'up' && !row.adelanto_min ? {...early, text: 'A tiempo'} : early;
                            return (
                                <li key={`${row.fecha}-${row.id_empleado}`} className="mc-list__item mc-list__item--timeline">
                                    <EmployeeName row={row}/>
                                    <span className="mc-list__time mc-num">
                                        {hhmm(row.entrada)}
                                        {multiDay && <small>{shortDayLabel(row.fecha)}</small>}
                                    </span>
                                    <StatusBadge tone={arrival.tone} text={arrival.text}/>
                                    <BarraJornada row={row} today={today}/>
                                </li>
                            );
                        })}
                    </ul>
                    <Paginator page={current.page} pages={current.pages} onChange={setPage}/>
                </div>
            </StateView>
        </section>
    );
};

export default Ingresos;
